// extracted by mini-css-extract-plugin
export var container = "_6a-0";
export var infoButton = "_6a-1";
export var label = "_6a-3";
export var labelExpanded = "_6a-4";
export var price = "_6a-5";
export var priceExpanded = "_6a-6";
export var title = "_6a-2";